var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("SoliForm", {
        ref: "form",
        attrs: {
          title: _vm.product.name,
          textSubtitle: _vm.$page.props.auth.user.selected_location.name,
        },
        on: {
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          submit: function ($event) {
            return _vm.submit()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  _c("SoliText", {
                    attrs: {
                      number: "",
                      label: "Current Supply",
                      icon: "inventory_2",
                    },
                    model: {
                      value: _vm.form.current_stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "current_stock", $$v)
                      },
                      expression: "form.current_stock",
                    },
                  }),
                  _vm._v(" "),
                  _c("SoliText", {
                    attrs: {
                      number: "",
                      label: "Recommended Supply",
                      icon: "assignment_turned_in",
                    },
                    model: {
                      value: _vm.form.recommended_stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recommended_stock", $$v)
                      },
                      expression: "form.recommended_stock",
                    },
                  }),
                  _vm._v(" "),
                  _c("SoliText", {
                    attrs: {
                      number: "",
                      label: "Warning Supply",
                      icon: "warning_amber",
                    },
                    model: {
                      value: _vm.form.warning_stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "warning_stock", $$v)
                      },
                      expression: "form.warning_stock",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3241046033
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }